import type { GenericAbortSignal } from 'axios';
import type {
  GetInstallmentPaymentDetailsParams,
  GetInstallmentPaymentDetailsResponse,
  GetInstallmentTotalPaymentsParams,
  GetInstallmentTotalPaymentsResponse,
} from './Installment.types';
import { serializeToFormDataDefaultRequestKeys } from '@/app/plugins/http/http.utils';
import { BaseService, defineApi } from '@/shared/api';

class InstallmentService extends BaseService {
  /** https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/311492609/WEB+Q+Get+Installment+Payment+Details */
  async getInstallmentPaymentDetails(
    params: GetInstallmentPaymentDetailsParams,
  ): Promise<GetInstallmentPaymentDetailsResponse> {
    const payload = serializeToFormDataDefaultRequestKeys(params);
    return await this.post('/instgetpayments', payload);
  }

  /** https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/311459873/WEB+Q+Get+Total+Installment+Payment */
  async getInstallmentTotalPayments(
    params: GetInstallmentTotalPaymentsParams,
    signal?: GenericAbortSignal,
  ): Promise<GetInstallmentTotalPaymentsResponse> {
    const payload = serializeToFormDataDefaultRequestKeys({
      ...params,
      isFull: params.isFull ? 1 : 0,
      isSelectProduct: params.isSelectProduct ? 1 : 0,
    });
    return await this.post('/getinsttotalpayments', payload, { signal });
  }
}

export const useInstallmentService = defineApi(InstallmentService);
